<template>
    <b-modal
        id="file-upload-modal"
        v-model="create_new_file_modal"
        hide-footer
        :title="$t('files.create_new_file')"
        modal-class="apprentice-default-modal"
        @show="show">
        <div class="file-upload">
            <b-alert show="info"
                >{{ $t('files.maximum_upload_size_is') }}<span class="tex-danger">3000MB</span>.
            </b-alert>

            <b-form
                @submit="onSubmit"
                @reset="onReset"
                enctype="multipart/form-data">
                <b-form-group
                    :label="$t('common.name')"
                    label-for="file-upload-name">
                    <b-form-input
                        id="file-upload-name"
                        v-model="form.name"
                        required
                        :placeholder="$t('files.fill_in_file_name')"></b-form-input>
                </b-form-group>

                <b-form-group
                    :label="$t('common.description')"
                    label-for="ifile-upload-description">
                    <b-form-input
                        id="file-upload-description"
                        v-model="form.description"
                        :placeholder="$t('files.fill_a_description_in')"></b-form-input>
                </b-form-group>

                <b-form-group
                    v-if="!isStudent"
                    :label="$t('files.visibility')"
                    label-for="file-upload-visibility">
                    <b-form-select
                        class="apprentice-primary-select file-upload"
                        id="file-upload-visibility"
                        v-model="form.visibility"
                        :options="visibility"></b-form-select>
                </b-form-group>

                <b-form-file
                    class="apprentice-file-upload"
                    v-model="form.file"
                    :state="Boolean(form.file)"
                    :placeholder="$t('files.choose_file')"
                    drop-placeholder="Drop file here..."></b-form-file>

                <div class="mt-3">{{ $t('files.selected_file') }}: {{ form.file ? form.file.name : '' }}</div>

                <div class="file-upload-save">
                    <b-button
                        class="btn-upload btn-file-uplaod"
                        type="submit"
                        variant="primary">
                        {{ $t('files.upload_file') }}
                    </b-button>
                </div>
            </b-form>
        </div>
    </b-modal>
</template>

<script>
import { FilesBus } from '../../app';

export default {
    name: 'design-2021-file-upload-modal-component',
    props: ['projectId'],
    data() {
        return {
            form: {
                description: '',
                name: '',
                file: null,
                visibility: 0,
            },
            files_count: null,
            files_size: '',
            visibility: [
                {
                    text: this.$t('files.students_and_teachers'),
                    value: 0,
                },
                { text: this.$t('files.only_teachers'), value: 1 },
            ],
            create_new_file_modal: false,
            isStudent: AuthIsStudent,
        };
    },
    methods: {
        show() {
            this.form = {
                description: '',
                name: '',
                file: null,
                visibility: 0,
            };
            this.files_count = null;
            this.files_size = '';
            this.create_new_file_modal = false;
        },
        onSubmit(evt) {
            evt.preventDefault();
            let formData = new FormData();

            formData.append('file', this.form.file);
            formData.append('description', this.form.description);
            if (!this.isStudent) {
                formData.append('visibility', this.form.visibility);
            } else {
                formData.append('visibility', 0);
            }
            formData.append('name', this.form.name);

            this.alert.saving();

            axios
                .post(this.routes.projectFilesCreate(this.projectId), formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((response) => {
                    this.alert.success();

                    this.create_new_file_modal = false;

                    FilesBus.$emit('pushData', '');
                })
                .catch((error) => {
                    this.alert.ajaxError(error);
                });
        },
        fileUploadSuccess() {
            this.alert.success(this.$t('files.this_file_is_successfully_saved'));

            this.create_new_file_modal = false;

            FilesBus.$emit('pushData', '');
        },
        createNewFile() {
            this.create_new_file_modal = true;
        },
        updateFilesCount(count) {
            this.files_count = count;
        },
        updateFilesSize(file_size) {
            this.files_size = file_size;
        },
        onReset(evt) {
            evt.preventDefault();
            // Reset our form values
            this.form.description = '';
            this.form.name = '';
            this.form.visibility = 0;
            this.form.file = null;
        },
    },
    created() {
        FilesBus.$on('updateFileCount', (count) => {
            this.updateFilesCount(count);
        });

        FilesBus.$on('updateFileSize', (file_size) => {
            this.updateFilesSize(file_size);
        });
    },
};
</script>

<style scoped lang="scss">
.file-upload {
    margin-bottom: 0;
}

.file-upload-save {
    display: flex;
    justify-content: flex-end;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
